const print = {
    breakLine: function (length, symbol = "-") {
        let result = "";
        for (let index = 0; index < length; index++) {
            result += symbol;
        }
        return result;
    },
    oneLine: function (str, chunkSize, align = "left") {
        if (typeof str !== "string") throw new Error("Input harus berupa string!");
        if (!Number.isInteger(chunkSize) || chunkSize <= 0) throw new Error("chunkSize harus bilangan bulat positif!");

        let words = str.split(" "); // Pisahkan kata-kata berdasarkan spasi
        let result = [];
        let line = "";

        words.forEach(word => {
            // Jika kata berikutnya melebihi batas, simpan baris saat ini dan mulai baris baru
            if ((line + word).length > chunkSize) {
                result.push(this.alignText(line.trim(), chunkSize, align));
                line = word + " ";
            } else {
                line += word + " ";
            }
        });

        // Tambahkan baris terakhir jika ada
        if (line.trim().length > 0) {
            result.push(this.alignText(line.trim(), chunkSize, align));
        }

        return this.joinRows(result);
    },
    twoColumn: function (leftText, rightText, leftColSize, spaceSize, rightColSize) {
        let result = [];
        // Ensure consistent spacing by using non-breaking spaces
        let spaceStr = " ".repeat(spaceSize); // Spasi pemisah antar kolom

        // Make sure text is properly formatted as string
        leftText = String(leftText || "");
        rightText = String(rightText || "");

        let leftChunks = this.chunkTextPreserveSpace(leftText, leftColSize);
        let rightChunks = this.chunkTextRightAlign(rightText, rightColSize);

        let maxLines = Math.max(leftChunks.length, rightChunks.length);

        for (let i = 0; i < maxLines; i++) {
            // Ensure exact column width for consistent alignment
            let leftPart = (leftChunks[i] || "").padEnd(leftColSize, " "); // Rata kiri
            let rightPart = (rightChunks[i] || "").padStart(rightColSize, " "); // Rata kanan

            result.push(leftPart + spaceStr + rightPart);
        }

        return result.join("\n");
    },
    twoColumnLeftAlign: function (leftText, rightText, leftColSize, spaceSize, rightColSize) {
        let result = [];
        let spaceStr = " ".repeat(spaceSize); // Spasi pemisah antar kolom
        let indent = "  "; // Dua spasi untuk baris baru di kolom kanan

        // Pisahkan teks berdasarkan kata
        let leftChunks = this.chunkText(leftText, leftColSize);
        let rightChunks = this.chunkTextPreserveSpaceWithIndent(rightText, rightColSize, indent);

        // Maksimum jumlah baris yang dibutuhkan
        let maxLines = Math.max(leftChunks.length, rightChunks.length);

        for (let i = 0; i < maxLines; i++) {
            let leftPart = leftChunks[i] || ""; // Jika tidak ada teks, isi dengan string kosong
            let rightPart = rightChunks[i] || "";

            // Rata kiri dengan memastikan setiap bagian memiliki panjang sesuai ukuran kolom
            leftPart = leftPart.padEnd(leftColSize, " ");

            result.push(leftPart + spaceStr + rightPart);
        }

        return result.join("\n"); // Gabungkan baris dengan newline
    },
    tablePrint: function (left, right, maks) {
        const countLeft = left.length;
        const countRight = right.length;
        let result = [];
        for (let index = 0; index < maks; index++) {
            result[index] = countLeft > index ? left[index] : " ";
        }

        let indexRight = countRight;
        for (let index = (maks - 1); index >= 0; index--) {
            if ((maks - countRight) <= index) {
                indexRight--;
                result[index] = right[indexRight];
            }
        }
        return result.join("");
    },
    centerTextByCharacter: function (text, maxLength) {
        if (typeof text !== "string") throw new Error("Input harus berupa string!");
        if (!Number.isInteger(maxLength) || maxLength <= 0) throw new Error("maxLength harus bilangan bulat positif!");

        let words = text.split(" ");
        let lines = [];
        let currentLine = "";

        for (let word of words) {
            if ((currentLine.length + word.length + (currentLine.length > 0 ? 1 : 0)) <= maxLength) {
                // Tambahkan kata ke baris jika masih cukup
                currentLine += (currentLine.length === 0 ? "" : " ") + word;
            } else {
                // Simpan baris sebelumnya dengan rata tengah
                let paddingLeft = Math.max(0, Math.floor((maxLength - currentLine.length) / 2));
                let paddingRight = Math.max(0, maxLength - currentLine.length - paddingLeft);
                lines.push(" ".repeat(paddingLeft) + currentLine + " ".repeat(paddingRight));

                // Mulai baris baru dengan kata saat ini
                currentLine = word;
            }
        }

        // Tambahkan baris terakhir jika ada
        if (currentLine.length > 0) {
            let paddingLeft = Math.max(0, Math.floor((maxLength - currentLine.length) / 2));
            let paddingRight = Math.max(0, maxLength - currentLine.length - paddingLeft);
            lines.push(" ".repeat(paddingLeft) + currentLine + " ".repeat(paddingRight));
        }

        return this.joinRows(lines);
    },
    joinRows(array) {
        if (!Array.isArray(array[0])) {
            return array.join(""); // Jika hanya 1 dimensi, gabungkan langsung jadi 1 baris
        }

        return array.map(row => row.join("")).join("\n");
    },
    // Fungsi untuk meratakan teks sesuai dengan opsi (left, center, right)
    alignText: function (text, maxLength, align) {
        if (align === "center") {
            let paddingLeft = Math.floor((maxLength - text.length) / 2);
            let paddingRight = maxLength - text.length - paddingLeft;
            return " ".repeat(paddingLeft) + text + " ".repeat(paddingRight);
        }
        if (align === "right") {
            return text.padStart(maxLength, " ");
        }
        return text.padEnd(maxLength, " "); // Default rata kiri
    },
    // Fungsi untuk memecah teks berdasarkan kata dan mempertahankan spasi awal
    chunkTextPreserveSpace: function (text, chunkSize) {
        // Ensure text is a string
        text = String(text || "");
        
        let words = text.split(/(\s+)/); // Pisahkan berdasarkan spasi (termasuk spasi sebagai token)
        let result = [];
        let line = "";

        words.forEach((word) => {
            if ((line + word).length > chunkSize) {
                // Ensure exact width for consistent alignment
                result.push(line.padEnd(chunkSize, " ")); // Tambahkan padding jika kurang dari chunkSize
                line = word.trimStart(); // Mulai baris baru dengan menghapus spasi awal yang berlebih
            } else {
                line += word;
            }
        });

        if (line.length > 0) {
            // Ensure exact width for consistent alignment
            result.push(line.padEnd(chunkSize, " "));
        }
        
        // If no results, add an empty line with proper padding
        if (result.length === 0) {
            result.push("".padEnd(chunkSize, " "));
        }

        return result;
    },
    // Fungsi untuk memecah teks kanan dan memastikan rata kanan
    chunkTextRightAlign: function (text, chunkSize) {
        // Ensure text is a string
        text = String(text || "");
        
        let words = text.split(" ");
        let result = [];
        let line = "";

        words.forEach((word, index) => {
            let wordWithSpace = (index === 0 ? "" : " ") + word; // Tambahkan spasi antar kata

            if ((line + wordWithSpace).length > chunkSize) {
                // Ensure exact width for consistent alignment
                result.push(line.padStart(chunkSize, " ")); // Pastikan teks rata kanan
                line = word; // Mulai baris baru
            } else {
                line += wordWithSpace;
            }
        });

        if (line.length > 0) {
            // Ensure exact width for consistent alignment
            result.push(line.padStart(chunkSize, " "));
        }
        
        // If no results, add an empty line with proper padding
        if (result.length === 0) {
            result.push("".padStart(chunkSize, " "));
        }

        return result;
    },
    // Fungsi untuk memecah teks kanan dengan indentasi 2 spasi di baris baru
    chunkTextPreserveSpaceWithIndent: function (text, chunkSize, indent) {
        let words = text.split(/(\s+)/); // Pisahkan berdasarkan spasi (termasuk spasi sebagai token)
        let result = [];
        let line = "";
        let firstLine = true;

        words.forEach((word) => {
            let effectiveChunkSize = firstLine ? chunkSize : chunkSize - indent.length;

            if ((line + word).length > effectiveChunkSize) {
                result.push(line.padEnd(effectiveChunkSize, " "));

                // Hilangkan spasi sebelum kata jika ada, tetapi tetap tambahkan indentasi 2 spasi
                line = indent + word.trimStart();
                firstLine = false;
            } else {
                line += word;
            }
        });

        if (line.length > 0) {
            result.push(line.padEnd(firstLine ? chunkSize : chunkSize - indent.length, " "));
        }

        return result;
    },
    chunkText: function (text, maxLength) {
        let words = text.split(" ");
        let result = [];
        let line = "";

        for (let word of words) {
            if ((line + word).length > maxLength) {
                result.push(line.trim()); // Simpan baris yang sudah penuh
                line = word + " "; // Mulai baris baru dengan kata berikutnya
            } else {
                line += word + " ";
            }
        }

        if (line.trim().length > 0) {
            result.push(line.trim()); // Simpan baris terakhir jika ada
        }

        return result;
    },
    formatDate(date) {
        if (!date) return "-";
        const d = new Date(date);
        const pad = (num) => num.toString().padStart(2, "0");
  
        const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
        const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
  
        const dayName = days[d.getDay()];
        const day = pad(d.getDate());
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
  
        return `${dayName}, ${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
    },
    encodeBarcode(value) {
        const encoder = new TextEncoder();
        const commands = [
          0x1D, 0x48, 0x02,                  // Print barcode text below
          0x1D, 0x77, 0x02,                  // Barcode width (2 = medium)
          0x1D, 0x68, 0x50,                  // Barcode height (80)
          0x1D, 0x6B, 0x49, value.length,    // 1D barcode, CODE128, length
          ...encoder.encode(value)
        ];
        return new Uint8Array(commands);
    },
    buildQrCodeCommand(data) {
        const encoder = new TextEncoder();
        const storeLen = data.length + 3;
        const pL = storeLen % 256;
        const pH = Math.floor(storeLen / 256);
      
        const cmds = [
          // Set QR code model
          [0x1D, 0x28, 0x6B, 0x04, 0x00, 0x31, 0x41, 0x32, 0x00],
          // Set QR code size (6 = 58x58 dots, larger than default)
          [0x1D, 0x28, 0x6B, 0x03, 0x00, 0x31, 0x43, 0x08],
          // Set error correction level (L=7%, M=15%, Q=25%, H=30%)
          [0x1D, 0x28, 0x6B, 0x03, 0x00, 0x31, 0x45, 0x31],
          // Center the QR code (GS L nL nH)
          [0x1D, 0x4C, 0x30, 0x00],
          // Store QR code data
          [0x1D, 0x28, 0x6B, pL, pH, 0x31, 0x50, 0x30, ...encoder.encode(data)],
          // Print QR code
          [0x1D, 0x28, 0x6B, 0x03, 0x00, 0x31, 0x51, 0x30],
          // Add some line feeds after QR code
          [0x0A, 0x0A]
        ];
      
        return new Uint8Array(cmds.flat());
    }
}

export default print;